import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
import {floorThumbnail} from "../../../kvComponent/core/assets";

import {IntermediatePart} from "../intermediatePart";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";

export default class Floor extends Part {
  static id = 'Floor';

  constructor() {
    super(true, false, PartMenuType.Complex);
    this.partId = 'parent_floor';
    this.menuType = PartMenuType.Complex;
    this.partName = 'Floor';
    this.translateId = "visualizer.kitchen.kitchen_floor";
    this.partThumbnail = floorThumbnail;
  }

  load(dbFeature) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Flor":
      case "Floor":
        relatedItemName = "floorBody";
        RelatedItemClass = FloorBody;
        break;
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        if (relatedItemName !== "shadows") {
          this.relatedItems.push(this[relatedItemName]);
        }
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

  navigationItem() {
    return new DesignNavigationItem('Floor', this);
  }

}

class FloorBody extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'kitchen_floor';
    this.partName = 'Floor';
    this.translateId = "visualizer.kitchen.kitchen_floor";
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new FloorBody());
  }
}


